var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94481 12C6.7891 12 6.64312 11.9774 6.50687 11.9323C6.37062 11.8872 6.24411 11.8113 6.12732 11.7047L1.10558 7.08724C0.891476 6.89037 0.789095 6.63516 0.798438 6.3216C0.80778 6.00804 0.919893 5.75319 1.13478 5.55704C1.34888 5.36017 1.62138 5.26174 1.95227 5.26174C2.28316 5.26174 2.55566 5.36017 2.76976 5.55704L6.94481 9.39596L16.8423 0.295302C17.0564 0.0984339 17.334 0 17.675 0C18.016 0 18.2932 0.0984339 18.5065 0.295302C18.7206 0.492169 18.8277 0.747381 18.8277 1.06094C18.8277 1.37449 18.7206 1.62935 18.5065 1.8255L7.76231 11.7047C7.64552 11.8121 7.51901 11.8883 7.38276 11.9334C7.24651 11.9785 7.10053 12.0007 6.94481 12Z",
    fill: "#72B7A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.1767a1ee0e1590560c69aa7032d37a7b.svg";
export { ForwardRef as ReactComponent };